import type { RouteObject } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import Home from '@/pages/home/page';
import Article from '@/pages/article/page';
import PillarArticle from '@/pages/article/PillarArticle';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/allchinabuy-spreadsheet-guide',
    element: <Article />,
  },
  {
    path: '/allchinabuy-review',
    element: <PillarArticle />,
  },
  {
    path: '/allchinabuy-shipping-cost',
    element: <PillarArticle />,
  },
  {
    path: '/allchinabuy-coupon',
    element: <PillarArticle />,
  },
  {
    path: '/allchinabuy-discount-code',
    element: <PillarArticle />,
  },
  {
    path: '/allchinabuy-warehouse',
    element: <PillarArticle />,
  },
  {
    path: '/allchinabuy-legit',
    element: <PillarArticle />,
  },
  {
    path: '/allchinabuy-qc',
    element: <PillarArticle />,
  },
  {
    path: '/allchinabuy-shipping',
    element: <PillarArticle />,
  },
  {
    path: '/allchinabuy-alternatives',
    element: <PillarArticle />,
  },
  {
    path: '/allchinabuy-tracking',
    element: <PillarArticle />,
  },
  // Unified dynamic route for future article links
  {
    path: '/article/:slug',
    element: <PillarArticle />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;